import React, { useEffect, useState } from "react";

//@ts-ignore
import s from "./PillowHint.module.scss";

export const PillowHint = ({ ...props }: any) => {
  const [isOpen, setIsOpen] = useState(false);

  function toggle() {
    setIsOpen(!isOpen);
  }

  return (
    <div className={s.hint} onClick={toggle}>
      <img src="/images/assets/svg/Bell.svg" alt="" />
      <span className={s.text}>
        Please keep in mind, that the
        <span className={s.red}> pillows are represented in actual size </span>
        <span className={`${s.short} ${isOpen && s.active}`}>and ...</span>
        <span className={`${s.full} ${isOpen && s.active}`}>
          and scale compared to the sofa.
        </span>
      </span>
    </div>
  );
};
